import { atom } from "jotai";

export const selectedAuditRoomIdsAtom = atom<string[]>([]);
export const alreadySelectedAuditRoomIdsAtom = atom<string[]>([]);
